<template>
  <div class="iphone box-border relative z-2 flex">
    <div class="absolute z-3 top-0 left-0 w-full h-full flex flex-col pointer-events-none">
      <div class="iphone-overlay-top bg-contain" />
      <div class="iphone-overlay-middle bg-contain flex-1" />
      <div class="iphone-overlay-bottom bg-contain" />
    </div>

    <div class="w-full relative bg-black flex-1 flex rounded-6xl overflow-hidden">
      <div
        class="h-15 w-full absolute z-2 top-0 left-0 bg-contain backdrop-filter bg-opacity-50 transition-colors duration-300 pointer-events-none"
        :class="{
          'backdrop-blur-md bg-white text-black': theme === 'light',
          'bg-black text-white': theme === 'dark',
        }"
      >
        <p class="iphone-time">{{ time }}</p>

        <svg class="w-full h-full" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M304.804 23.5h-1.167c-.644 0-1.166.504-1.166 1.125v9.75c0 .621.522 1.125 1.166 1.125h1.167c.644 0 1.167-.504 1.167-1.125v-9.75c0-.621-.523-1.125-1.167-1.125Zm-6.657 2.625h1.167c.644 0 1.166.504 1.166 1.125v7.125c0 .621-.522 1.125-1.166 1.125h-1.167c-.644 0-1.167-.504-1.167-1.125V27.25c0-.621.523-1.125 1.167-1.125Zm-4.323 2.625h-1.167c-.644 0-1.167.503-1.167 1.125v4.5c0 .621.523 1.125 1.167 1.125h1.167c.644 0 1.166-.504 1.166-1.125v-4.5c0-.622-.522-1.125-1.166-1.125ZM288.333 31h-1.166c-.645 0-1.167.503-1.167 1.125v2.25c0 .621.522 1.125 1.167 1.125h1.166c.645 0 1.167-.504 1.167-1.125v-2.25c0-.622-.522-1.125-1.167-1.125ZM320.971 25.846c2.467 0 4.839.97 6.626 2.711.135.135.35.133.483-.004l1.287-1.33a.374.374 0 0 0-.003-.52 11.925 11.925 0 0 0-16.786 0 .368.368 0 0 0-.107.26.37.37 0 0 0 .103.26l1.288 1.33a.336.336 0 0 0 .482.004 9.498 9.498 0 0 1 6.627-2.711Zm0 4.327c1.355 0 2.662.515 3.667 1.447a.34.34 0 0 0 .482-.007l1.285-1.33a.371.371 0 0 0-.005-.523 7.832 7.832 0 0 0-10.855 0 .37.37 0 0 0-.005.523l1.285 1.33a.34.34 0 0 0 .482.007 5.39 5.39 0 0 1 3.664-1.447Zm2.575 2.911a.362.362 0 0 1-.105.263l-2.223 2.297a.343.343 0 0 1-.494 0l-2.223-2.297a.362.362 0 0 1 .01-.521 3.742 3.742 0 0 1 4.92 0c.071.066.113.16.115.258Z" fill="currentColor"/><g clip-path="url(#a)"><rect opacity=".4" x="336.471" y="23.5" width="24" height="12" rx="3.5" stroke="#000"/><path opacity=".5" d="M361.971 27.5v4a2.17 2.17 0 0 0 0-4Z" fill="currentColor"/><rect x="337.971" y="25" width="17" height="9" rx="2" fill="currentColor"/></g><defs><clipPath id="a"><path fill="#fff" transform="translate(335.971 23)" d="M0 0h27.33v13H0z"/></clipPath></defs>
        </svg>
      </div>

      <div
        class="absolute z-6 top-0 left-0 w-full h-19"
        @click="$emit('click-topbar')"
      />

      <div class="iphone-pull" />

      <slot />
    </div>
  </div>
</template>

<script>
import { format } from 'date-fns';

export default {
  props: {
    theme: {
      type: String,
      default: 'light',
      validator: (val) => ['dark', 'light'].includes(val)
    }
  },
  setup() {
    return {
      get time() {
        const now = new Date()
        return format(now, 'HH:mm')
      }
    }
  }
}
</script>

<style lang="postcss">
.iphone {
  width: 442px;
  height: 895px;
  padding: 21px 24px 22px 25px;
}

.iphone-overlay-top {
  height: 398.457249115px;
  background: url('~@/assets/images/iphone-overlay-top.png') no-repeat;
}

.iphone-overlay-middle {
  background: url('~@/assets/images/iphone-overlay-middle.png') repeat-y;
}

.iphone-overlay-bottom {
  height: 106.80297399px;
  background: url('~@/assets/images/iphone-overlay-bottom.png') no-repeat;
}

.iphone-pull {
  width: 134px;
  height: 6px;
  bottom: 6px;

  @apply absolute z-3 left-0 right-0 mx-auto bg-black rounded-full;
}

.iphone-time {
  font-size: 17px;
  letter-spacing: -0.5px;
  @apply absolute top-5 left-14 m-0 font-semibold;
}
</style>